<template>
  <div class="bg-neutral-300 p-8">
    <Lynx-Title
      :text="`${currentEmpresa.id} - ${currentEmpresa.razao_social}`"
    />

    <div v-if="currentEmpresa.guia_liberacao[0]">
      <v-card
        class="mb-4 p-1"
        elevation="10"
        v-if="currentEmpresa.guia_liberacao[0].motivoenvio"
      >
        <div class="flex justify-between items-center">
          <span
            >Motivo envio :
            {{ currentEmpresa.guia_liberacao[0].motivoenvio }}</span
          >

          <span class="mr-1">
            Usuario:
            {{ currentEmpresa.guia_liberacao[0].usuario.nome_completo }}</span
          >
        </div>
      </v-card>
    </div>
    <EmpresaPioridadeCard
      v-if="currentEmpresa.prioridade_empresa"
      :currentEmpresa="currentEmpresa"
      @atualizar="atualizouPrioridade()"
    />
    <div v-if="faturaCancelada">
      <v-card class="mb-4 p-1" elevation="10">
        <v-card-title>
          <div class="flex justify-between items-center">
            <span class="text-lg">Fatura Cancelada</span>
            <span class="text-lg"
              >Data:
              {{
                formatDate(faturaCancelada.motivo_cancelamento.created_at)
              }}</span
            >
          </div>
        </v-card-title>
        <v-card-text>
          <div class="flex flex-col space-y-2">
            <div>
              <span
                >Motivo : {{ faturaCancelada.motivo_cancelamento.nome }}</span
              >
              <span>
                Competência:
                {{ faturaCancelada.motivo_cancelamento.descricao }}
              </span>
            </div>
            <div class="flex justify-between items-center">
              <span
                class="my-3 shadow rounded p-2 text-neutral-300 bg-error-base"
              >
                Descrição:
                {{ descricaoLogsPrioridade("deleted") }}
              </span>
              <span class="mr-1">
                Usuário:
                {{ faturaCancelada.activities[0].nome_completo }}
              </span>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </div>

    <div class="modal-content">
      <b-notification
        v-if="thereIsErrorOnEnvio"
        type="is-danger"
        has-icon
        aria-close-label="Close notification"
        role="alert"
      >
        {{ errorMessage }}
      </b-notification>

      <b-notification
        v-if="currentEmpresa.pagamento_cartao"
        type="is-info"
        aria-close-label="Close notification"
        role="alert"
      >
        <b-icon icon="credit-card" size="is-small"></b-icon>
        Honorário em débito automático.
      </b-notification>

      <b-table :data="currentEmpresa.guias" :columns="columns">
        <template slot-scope="props">
          <b-table-column field="guia" v-text="props.row.tipo" />
          <b-table-column field="valor">
            <div v-if="props.row.valor != null">
              <v-row
                v-if="
                  hasRole('super-admin') | hasPermission('editar valor guias')
                "
              >
                <v-col v-if="editable != props.row.id">
                  <span>
                    R$
                    {{ props.row.valor[props.row.tipo.toLowerCase()] | money }}
                  </span>
                </v-col>
                <v-col v-else>
                  <InputMoney
                    required
                    @input="
                      (money) =>
                        (props.row.valor[props.row.tipo.toLowerCase()] = money)
                    "
                    v-model="props.row.valor[props.row.tipo.toLowerCase()]"
                  ></InputMoney>
                </v-col>

                <v-btn
                  small
                  class="mt-4"
                  @click.native="
                    editable == props.row.id
                      ? updateVal(props.row)
                      : toggleEditable(props.row.id)
                  "
                  color="primary"
                >
                  <v-icon size="20">{{
                    editable == props.row.id ? "mdi-content-save" : "mdi-pencil"
                  }}</v-icon>
                </v-btn>
              </v-row>
            </div>
          </b-table-column>

          <b-table-column field="data">
            {{ props.row | data_upload }}
          </b-table-column>
          <b-table-column field="acoes">
            <div class="flex text-sm items-center">
              <a
                :href="getGuiaLink(props.row.arquivo_id)"
                target="_blank"
                class="mr-4 bg-primary-600 rounded-full p-2"
              >
                <Icon-Eye class="text-neutral-100" size="4" />
              </a>
              <a
                href="#"
                class="bg-error-base rounded-full p-2"
                @click.prevent="estornaGuia(props.row)"
              >
                <Icon-Trash class="text-neutral-100" size="4" />
              </a>
            </div>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  estornarGuiaRequest,
  updataValGuiaRequest,
} from "@/services/requests/guias";
import { puxarFaturaCancelada } from "@/services/requests/faturas";
import moment from "moment";
import InputMoney from "@/components/helpers/InputMoney";
import { hasRole, hasPermission } from "@/utils/can";
import EmpresaPioridadeCard from "@/views/components/EmpresaPioridadeCard";
export default {
  name: "GerenciamentoGuiasDetails",
  props: ["currentEmpresa"],
  components: { InputMoney, EmpresaPioridadeCard },

  data() {
    return {
      editable: null,
      guiaValor: 0,
      faturaCancelada: null,
      columns: [
        {
          field: "guia",
          label: "Guia",
        },
        {
          field: "valor",
          label: "Valor",
        },
        {
          field: "data_upload",
          label: "Upload",
          width: 150,
        },
        {
          field: "acoes",
          label: "Ações",
          width: 150,
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    thereIsErrorOnEnvio() {
      const liberacao = this.currentEmpresa.guia_liberacao[0];
      return liberacao && liberacao.erro_envio && !liberacao.data_envio;
    },
    errorMessage() {
      const liberacao = this.currentEmpresa.guia_liberacao[0];
      return liberacao.error_message || "Erro no envio de e-mail";
    },
  },
  created() {
    this.puxarHonorarioVencido();
  },
  methods: {
    hasRole,
    hasPermission,

    getGuiaLink(val) {
      return `${process.env.VUE_APP_API_URL}/arquivos/${val}/open?token=${this.getToken}`;
    },
    estornaGuia(guia) {
      this.$buefy.dialog.confirm({
        title: "Estornar Guia",
        message: "Tem certeza que deseja estornar a guia " + guia.tipo + " ?",
        confirmText: "Estornar",
        cancelText: "Cancelar",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          estornarGuiaRequest(guia.id).then(() => {
            this.currentEmpresa.guias = this.currentEmpresa.guias.filter(
              (item) => item !== guia
            );
            this.$emit("estornar");
          });
        },
      });
    },

    toggleEditable($id) {
      this.editable = this.editable == $id ? null : $id;
    },

    updateVal(data) {
      // Implemente a lógica para atualizar os valores aqui
      let guia = { id: data.id, valor: data.valor };
      this.$buefy.dialog.confirm({
        title: "Estornar Guia",
        message:
          "Tem certeza que deseja alterar o valor da guia " + guia.tipo + " ?",
        confirmText: "Sim",
        cancelText: "Não",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          updataValGuiaRequest(guia).then(() => {
            this.$emit("atualizar");
          });
        },
      });
    },
    descricaoLogsPrioridade(description) {
      let descricao = {
        created: "Criou",
        updated: "Atualizou",
        deleted: "Deletou",
      };
      return descricao[description];
    },
    formatDate(dia) {
      return moment().set("date", dia).format("DD/MM/YYYY");
    },
    async puxarHonorarioVencido() {
      if (this.currentEmpresa.guia_liberacao[0]) {
        let params = {
          competencia: this.currentEmpresa.guia_liberacao[0].competencia,
          empresa_id: this.currentEmpresa.id,
        };

        await puxarFaturaCancelada(params).then((res) => {
          this.faturaCancelada = res.data;
        });
      }
    },

    atualizouPrioridade() {
      this.toggleEditable();
      this.$emit("atualizar");
    },
  },
  filters: {
    money: (value) => {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    data_upload(guia) {
      if (guia.data_upload) {
        return new Date(guia.data_upload).toLocaleString();
      }
    },
  },
};
</script>

<style>
</style>
